import React, { useState } from 'react'
import Chart from 'react-apexcharts'
import ApexCharts from 'apexcharts'
import { IDadosGraficosResultadosPorDimensaoPesquisaModel } from '../helpers/AnaliseResultadoHelper'

type Props = {
  dadosGraficosPesquisa: IDadosGraficosResultadosPorDimensaoPesquisaModel | undefined
}

const GraficoResultadosPorDimensao  = ({dadosGraficosPesquisa}:Props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)

  let stackType: any = '100%'

  let options = {
    colors : dadosGraficosPesquisa?.Colors ?? [],
    series: dadosGraficosPesquisa?.Series ?? [],
    chart: {
      id: 'grafico-por-dimensao',
      stacked: true,
      stackType: stackType,
      toolbar: {
        show: false
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: dadosGraficosPesquisa?.Categories ?? [],
      labels: {
        rotate: -45,
        rotateAlways: true,
        trim: false,
        minHeight: 110,
        maxHeight: 130
      }
    },
    fill: {
      opacity: 1    
    },
    legend: {
      offsetX: 0,
      offsetY: 10,
      inverseOrder: true
    },
    grid: {
      padding: {
        right: 25,
        bottom: 20,
        left: 10
      }
    }
  }

  const downloadChart = (format: 'png' | 'jpeg') => {
    ApexCharts.exec('grafico-por-dimensao', 'dataURI').then((res: { imgURI: string }) => {
      const link = document.createElement('a')
      link.href = res.imgURI
      link.download = `grafico_por_dimensao.${format}`
      link.click()
    }).catch((e: any) => {
      console.error('Erro ao gerar download do gráfico:', e)
    })
  }
  
  return (
    <>
      <div className={`card m-0 p-0 ${dadosGraficosPesquisa ? '' : 'd-none'}`}>        
        <div className='card-body m-0 p-0'>

          {/* Botão ☰ para download */}
          <div className="d-flex justify-content-end px-5 pt-2 mb-2">
            <div className="dropdown">
              <button
                className="btn btn-light btn-sm dropdown-toggle"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                ☰
              </button>
              <div
                className={`dropdown-menu dropdown-menu-end ${dropdownOpen ? 'show' : ''}`}
                style={{ minWidth: '160px' }}
              >
                <button className="dropdown-item" onClick={() => downloadChart('png')}>
                  Baixar PNG
                </button>
                <button className="dropdown-item" onClick={() => downloadChart('jpeg')}>
                  Baixar JPEG
                </button>
              </div>
            </div>
          </div>

          <div className='row justify-content-center m-0 p-0'>
            <Chart options={options} series={options.series} type="bar" height={'460px'} />
          </div>
        </div>        
      </div> 
    </>         
  )
}
  
export {GraficoResultadosPorDimensao}
